import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Option from '../Option';
import { SelectContainer, OptionContainer } from './Select.styles';

/**
 * Renders a custom `select` element.
 *
 * @public
 * @author Connor Taylor
 */
class Select extends Component {
  onChange = (e) => this.props.onChange(e.target.value);

  render() {
    const { items, className, ...rest } = this.props;
    const optionElems = items.map((o) => (
      <Option value={o.value} key={o.label}>
        {o.label}
      </Option>
    ));

    return (
      <SelectContainer className={className}>
        <OptionContainer onChange={this.onChange} {...rest}>
          {optionElems}
        </OptionContainer>
      </SelectContainer>
    );
  }
}

Select.defaultProps = {
  items: [],
};

Select.propTypes = {
  /** The array of items to display in the select */
  items: PropTypes.array.isRequired,
  /** A function that fires any time an option is selected */
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Select;
